/* global Sys, NetEntExtend */
Sys.ns("NetEntExtend.API.Restricted");

/**
 * Restricted NetEntExtend Getters, only available if gameEventSetters.enabled = true (in game server init).
 *
 * @class NetEntExtend.API.Restricted.Getters
 * @extends NetEntExtend.API.Getters
 */
NetEntExtend.API.Restricted.Getters = Sys.apply(Sys.clone(NetEntExtend.API.Getters), {

});
